export default __webpack_public_path__ + "static/media/Data-not-found2.514c914f.svg";